import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { useGetIdentity, useGetOne } from "ra-core";
import { useSearchParams } from "react-router";
import { buildContractDefaultsFromDeal } from "./contractModel";
import { ContractInputs } from "./ContractInputs";
import type { Deal } from "../types";

export const ContractCreate = () => {
  const { identity } = useGetIdentity();
  const [searchParams] = useSearchParams();
  const dealId = searchParams.get("deal_id");
  const { data: deal } = useGetOne<Deal>(
    "deals",
    { id: dealId! },
    { enabled: Boolean(dealId) },
  );
  const defaultValues = {
    sales_id: identity?.id,
    status: "active",
    payment_type: "one_time",
    total_amount: 0,
    start_date: new Date().toISOString().slice(0, 10),
    payment_schedule: {},
    ...(deal ? buildContractDefaultsFromDeal(deal) : {}),
  };

  return (
    <Create mutationMode="pessimistic" redirect="show">
      <SimpleForm className="max-w-4xl" defaultValues={defaultValues}>
        <ContractInputs />
      </SimpleForm>
    </Create>
  );
};
